import { render, staticRenderFns } from "./Industry.vue?vue&type=template&id=0af6a980&scoped=true"
import script from "./Industry.vue?vue&type=script&lang=js"
export * from "./Industry.vue?vue&type=script&lang=js"
import style0 from "./Industry.vue?vue&type=style&index=0&id=0af6a980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af6a980",
  null
  
)

export default component.exports